export const BRAND_ID = 'DF3C4C78-8C0E-4688-B0A7-A6C4B6A7F988';

// Accent (003) still chats via CommunicationHub/Twilio; all other brands use the omnichannel 1-on-1 chat.
export const ACCENT_BRAND_ID = '4B0C292F-5688-4FAA-9C7B-4431B9F0BE54';

